import { ref } from "@vue/composition-api";

let isLoggedIn = null;

export function useLoggedInStatus() {
  if (isLoggedIn === null) {
    isLoggedIn = ref(window.Distinction && window.Distinction.loggedInStatus);
  }

  function setIsLoggedIn(truthy) {
    isLoggedIn.value = truthy;
  }
  return {
    isLoggedIn,
    setIsLoggedIn,
  };
}
